import { render } from "./OurServicesView.vue?vue&type=template&id=727a1bb4"
import script from "./OurServicesView.vue?vue&type=script&lang=js"
export * from "./OurServicesView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__